<template>
  <div class="form-wrapper">
    <h2>Signup</h2>
    <v-form v-model="valid">
      <v-row>
        <v-text-field
          v-model="credentials.username"
          id="username"
          :rules="usernameRules"
          label="Username"
          required
        >
        </v-text-field>
      </v-row>

      <v-row>
        <v-text-field
          v-model="credentials.email"
          id="email"
          type="email"
          label="E-mail"
          :rules="emailRules"
        ></v-text-field>
      </v-row>

      <v-row>
        <v-text-field
          v-model="credentials.password1"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="passwordRules"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          label="Password"
          hint="At least 8 characters"
          counter
          @click:append="show1 = !show1"
        ></v-text-field>
      </v-row>

      <v-row>
        <v-text-field
          v-model="credentials.password2"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="repeatPasswordRules"
          :type="show2 ? 'text' : 'password'"
          name="input-10-1"
          label="Repeat password"
          hint="At least 8 characters"
          counter
          @click:append="show2 = !show2"
        ></v-text-field>
      </v-row>
      <v-row class="form-actions-container">
        <v-btn v-if="!loading" :disabled="!valid" @click="signup">Submit</v-btn>
        <TinyLoaderLight v-if="loading" />
      </v-row>
      <v-row class="form-error-container">
        <p v-if="information">
          {{ information }}
        </p>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validEmail } from "@/utils/texts.util";
import TinyLoaderLight from "@/components/atoms/TinyLoaderLight";

export default {
  components: {
    TinyLoaderLight,
  },
  data() {
    return {
      valid: false,
      show1: false,
      show2: false,
      loading: false,
      information: "",
      usernameRules: [
        (v) => !!v || "Username is required",
        (v) => (v && v.length > 4) || "Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length > 7) || "Password must be more than 4 characters",
      ],
      repeatPasswordRules: [
        (v) =>
          (v && this.credentials.password1 == this.credentials.password2) ||
          "Passwords don't match",
      ],
      documents: null,
      credentials: {
        success: true,
        username: null,
        email: null,
        password1: "",
        password2: "",
      },
    };
  },
  methods: {
    async signup() {
      if (this.validCredentials && this.validEmail) {
        this.$store.commit("RESET_SIGNUP_ERROR");
        this.information = '';
        this.loading = true;
        let response = await this.$store.dispatch("signup", this.credentials);
        if (response && response.data && response.data.detail) {
          this.information = response.data.detail
        }
        if (response && response.data && response.data.response && response.data.response.data) {
          if (response.data.response.data.password1) {
            for (const info of (response.data.response.data.password1)) {
              this.information = info;
            }
          }
          if (response.data.response.data.email) {
            for (const info of (response.data.response.data.email)) {
              this.information = info;
            }
          }
          if (response.data.response.data.username) {
            for (const info of (response.data.response.data.username)) {
              this.information = info;
            }
          }
        }
        this.loading = false;
      }
    },
    cleanError() {
      this.$store.commit("RESET_SIGNUP_ERROR");
    },
  },
  computed: mapState({
    errors: (state) => state.errors.signup,
    validCredentials: function () {
      return (
        this.credentials.password1.length > 7 &&
        this.credentials.password1 === this.credentials.password2
      );
    },
    validEmail: function () {
      return validEmail(this.credentials.email);
    },
  }),
  mounted() {
    this.$store.commit("RESET_SIGNUP_ERROR");
  },
};
</script>


